import useFcmSmsCount from "../../../hooks/fcm/use-fcm-sms-count";
import useFcmEvents from "../FcmProvider";

type FcmEventListenerProps = {
  onSmsNotification?: (message: any) => void;
  onResetSmsCount?: (message: any) => void;
};

/**
 * Hook to listen to firebase sms notifications
 * @description useFcmSmsEventListener is a hook that listens to firebase sms notifications and updates the sms count
 *
 * @see useFcmEvents for more details about the firebase notifications wrapper for loose coupling of the code
 *
 * @returns [smsCount, setSmsCount]
 *
 * @author Rajkumar Rathod
 */
const useFcmSmsEventListener = ({
  onSmsNotification,
  onResetSmsCount,
}: FcmEventListenerProps) => {
  const [smsCount, setSmsCount] = useFcmSmsCount();

  /** listen to firebase sms notifications */
  useFcmEvents((message: any) => {
    if (!message?.notification_type) return;

    if (message?.notification_type === "incoming-sms") {
      setSmsCount(message?.unread_count);

      onSmsNotification?.(message);
    }

    if (message?.notification_type === "view-sms") {
      setSmsCount(0);

      onResetSmsCount?.(message);
    }
  });

  return [smsCount, setSmsCount];
};

export default useFcmSmsEventListener;
